import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { locomotorasService } from '../../services/api';

export default function HistorialFlota() {
  const [servicios, setServicios] = useState([]);
  const [locomotoras, setLocomotoras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroLoco, setFiltroLoco] = useState('');
  const [filtroFechaDesde, setFiltroFechaDesde] = useState('');
  const [filtroFechaHasta, setFiltroFechaHasta] = useState('');

  useEffect(() => {
    Promise.all([
      api.get('/servicios/'),
      locomotorasService.getAll()
    ]).then(([s, l]) => {
      setServicios(s.data);
      setLocomotoras(l.data.filter(l => l.activa));
    }).finally(() => setLoading(false));
  }, []);

  const filtrados = servicios.filter(s => {
    if (filtroLoco && s.locomotora !== filtroLoco) return false;
    if (filtroFechaDesde && new Date(s.fecha) < new Date(filtroFechaDesde)) return false;
    if (filtroFechaHasta && new Date(s.fecha) > new Date(filtroFechaHasta)) return false;
    return true;
  });

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Historial de flota</h2>
        <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Todos los servicios e incidencias</p>
      </div>

      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 16, marginBottom: 16, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Locomotora</label>
          <select value={filtroLoco} onChange={e => setFiltroLoco(e.target.value)}
            style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, minWidth: 140 }}>
            <option value="">Todas</option>
            {locomotoras.map(l => <option key={l.id} value={l.numero}>{l.numero}</option>)}
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Desde</label>
          <input type="date" value={filtroFechaDesde} onChange={e => setFiltroFechaDesde(e.target.value)}
            style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Hasta</label>
          <input type="date" value={filtroFechaHasta} onChange={e => setFiltroFechaHasta(e.target.value)}
            style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
        </div>
        <button onClick={() => { setFiltroLoco(''); setFiltroFechaDesde(''); setFiltroFechaHasta(''); }}
          style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
          Limpiar
        </button>
        <div style={{ marginLeft: 'auto', fontSize: 13, color: '#888', alignSelf: 'center' }}>
          {filtrados.length} registros
        </div>
      </div>

      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f8f8f6' }}>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Fecha</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Locomotora</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Maquinista</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>KM totales</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Descripcion</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Estado</th>
            </tr>
          </thead>
          <tbody>
            {filtrados.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 24, textAlign: 'center', color: '#aaa' }}>No hay registros</td></tr>
            )}
            {filtrados.slice(0, 100).map(s => (
              <tr key={s.id} style={{ borderTop: '1px solid #f0f0f0', opacity: s.anulado ? 0.5 : 1 }}>
                <td style={{ padding: '8px 14px' }}>{new Date(s.fecha).toLocaleDateString('es-ES')}</td>
                <td style={{ padding: '8px 14px', fontWeight: 500 }}>{s.locomotora}</td>
                <td style={{ padding: '8px 14px' }}>{s.maquinista || '—'}</td>
                <td style={{ padding: '8px 14px' }}>{s.km_totales ? `${Math.round(s.km_totales)} km` : '—'}</td>
                <td style={{ padding: '8px 14px', color: '#888', fontSize: 12 }}>{s.descripcion || '—'}</td>
                <td style={{ padding: '8px 14px' }}>
                  {s.anulado
                    ? <span style={{ background: '#f0f0f0', color: '#888', borderRadius: 20, padding: '2px 8px', fontSize: 11 }}>Anulado</span>
                    : <span style={{ background: '#eaf3de', color: '#3b6d11', borderRadius: 20, padding: '2px 8px', fontSize: 11 }}>Activo</span>
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
